import { Fragment, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import api from "../../../shared/utils/request";
import ProductViewV2 from "../../shared/productViewV2";
import "./flashSale.css";

const pad = (num) => String(num).padStart(2, "0");

const getTimeLeft = (endDateStr, endTimeStr, atTime = Date.now()) => {
  if (!endDateStr || !endTimeStr) return null;
  const match = endTimeStr.match(/(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(am|pm)?/i);
  if (!match) return null;
  const [, h, m, s, mer] = match;
  let hours = Number(h);
  const minutes = Number(m);
  const seconds = Number(s ?? 0);
  if (/pm/i.test(mer || "") && hours < 12) hours += 12;
  if (/am/i.test(mer || "") && hours === 12) hours = 0;
  const target = new Date(endDateStr);
  target.setHours(hours, minutes, seconds, 0);
  const diff = target.getTime() - atTime;
  if (Number.isNaN(target.getTime()) || diff <= 0) return { expired: true };
  return {
    expired: false,
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    minutes: Math.floor((diff % 3600000) / 60000),
    seconds: Math.floor((diff % 60000) / 1000),
  };
};

const isDealExpired = (section, atTime) =>
  getTimeLeft(section?.deal_end_date, section?.deal_end_time, atTime)
    ?.expired === true;

const DealCountdown = ({ endDate, endTime }) => {
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(endDate, endTime));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft(endDate, endTime));
    }, 1000);
    return () => clearInterval(timer);
  }, [endDate, endTime]);

  if (!timeLeft || timeLeft.expired) return null;

  const boxes = [
    { value: timeLeft.days, label: "Days" },
    { value: timeLeft.hours, label: "Hrs" },
    { value: timeLeft.minutes, label: "Min" },
    { value: timeLeft.seconds, label: "Sec" },
  ];

  return (
    <div className="flash-sale__timer">
      <span className="flash-sale__timer-label">Ends in</span>
      <div className="flash-sale__timer-boxes">
        {boxes.map((box, index) => (
          <Fragment key={box.label}>
            {index > 0 && <span className="flash-sale__timer-colon">:</span>}
            <div className="flash-sale__timer-box">
              <span className="flash-sale__timer-num" key={box.value}>
                {pad(box.value)}
              </span>
              <span className="lbl">{box.label}</span>
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

const DynamicSections = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const data = await api.get("customer/get-flash-sale-variants");
        const products = data?.data || [];
        setProducts(products);
      } catch (error) {
        console.error("Failed to fetch products:", error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);

  // const visibleSections = sections.filter(
  //   (section) => !isDealExpired(section, now),
  // );

  return (
    <>
      {/* {products?.map((product, sectionIndex) => ( */}
      {products?.length > 0 && (
        <section
          className="flash-sale"
          key={`section-dynamic`}
          // style={{ animationDelay: `${sectionIndex * 0.15}s` }}
        >
          <div className="container container-lg">
            <div className="flash-sale__inner">
              <span className="flash-sale__ring" />
              <span className="flash-sale__petal flash-sale__petal--1" />
              <span className="flash-sale__petal flash-sale__petal--2" />
              <span className="flash-sale__petal flash-sale__petal--3" />
              <div className="flash-sale__header">
                <div className="flash-sale__heading">
                  <span className="flash-sale__icon">
                    <span className="flash-sale__icon-ring" />
                    <i className="ph-bold ph-lightning" />
                  </span>
                  <div>
                    <h5 className="flash-sale__title mb-0">
                      <span className="flash-sale__title-accent">Flash</span>{" "}
                      Sale
                    </h5>
                    {/* {section.description && ( */}
                    <p className="flash-sale__subtitle mb-0">
                      Explore unlimited deals
                    </p>
                    {/* )} */}
                  </div>
                </div>

              </div>

              {loading ? (
                <div className="row g-12">
                  {Array.from({ length: 6 }).map((_, index) => (
                    <div
                      className="col-6 col-sm-4 col-lg-3 col-xxl-2"
                      key={index}
                    >
                      <div className="flash-sale__skeleton" />
                    </div>
                  ))}
                </div>
              ) : (
                <Swiper
                  modules={[Autoplay]}
                  spaceBetween={20}
                  slidesPerView={5}
                  loop={true}
                  autoplay={{
                    delay: 4000,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    320: { slidesPerView: 2.5 },
                    576: { slidesPerView: 3 },
                    768: { slidesPerView: 4 },
                    1024: { slidesPerView: 4 },
                    1200: { slidesPerView: 6.5 },
                  }}
                  className="flash-sale__slider"
                >
                  {products?.map((product, index) => (
                    <SwiperSlide key={product?.id || index}>
                      <ProductViewV2
                        index={index}
                        product={{
                          id: product?.id,
                          slug: product?.product?.slug,
                          variant_id: product?.id,
                          image: product?.product_image,
                          name: product?.title,
                          price: product?.sale_price,
                          originalPrice: product?.price,
                          quantityType: product?.quantity,
                          sold: product?.stock,
                          label: product?.label,
                        }}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              )}
            </div>
          </div>
        </section>
      )}
      {/* ))} */}
    </>
  );
};

export default DynamicSections;
